import { useContext, useEffect, useState } from 'react';
import '../../style/components/order_bar.css';
import '../../style/mediaquery/orderBar.css';
import Ticket from './ticket';
import { context } from '../../context/context';
import BackIcon from '../../docs/light/back.png'
import TrashIcon from '../../docs/light/trash.png'

import { InvoiceOrder } from '../invoices/invoice';
import { CurrentTime } from '../../funcs/current';
import { recodeNow, update } from '../indexDB/indexDBStora';
import { config } from '../../context/config';
import { switchh } from '../../context/switch';
import { Setting } from '../../context/settings';
import { auth } from '../../context/auth';
import { action } from '../../context/action';
import { intialData } from '../../context/initial';
import { collection } from '../../context/collect';
import Returns from './returns';
import { MakeAsync } from '../../funcs/MakeAsync';
import { useTranslation } from 'react-i18next';
import useNewInvoice from '../../funcs/hooks/useInvoice';
import { toast } from "react-toastify";
import { references } from '../../context/ref';
import useTechniqueOffset from '../../funcs/hooks/inventory.service/useTechnique';

export default function OrderBar() {
    const { t } = useTranslation();
    // ref of serial
    
    const { SerialInput, CashingBtn } = useContext(references);
    const { hide, isDesktop, fallbackDuartion } = useContext(config);
    const { storeConfig, storeSociety, storeInvoice } = useContext(Setting);
    const { user, ActivEmp } = useContext(auth);
    const { setEnablePayOnline } = useContext(action);
    const { setEnableDelivery, setLoadingProcess, setEnableReturns, enableReturns, initialReturn, setAccess, loadingProcess } = useContext(switchh);
    const { cart, setSerial, serial, setCart, product, setAddOne, ResetSerial, invoiceNum, total, discount2, pointer } = useContext(context);
    const { intialClient } = useContext(intialData);
    const { client, setClient } = useContext(collection);
    const { offsetBatch } = useTechniqueOffset();

    const [money, setMoney] = useState("") 

    const visaTotal = total;

    // required info of invoice (information device & employee )
    const empInfo = {
        id: ActivEmp?.code || "",
        name: ActivEmp?.name || ""
    };
    const infoSystem = {
        branch: user?.work?.workName || "",
        storeNumber: user?.work?.store || "",
        posStorageId: storeConfig?.pos || ""
    }


    const currencyData = user?.data?.[0]?.currency || {};

    const invoice = useNewInvoice();
    const NewInvCash = async () => {
    await setLoadingProcess(true);

    if (!cart || cart.length === 0) {
        setLoadingProcess(false);
        return;
    }

    if (invoiceNum === 0) {
        setLoadingProcess(false);
        return;
    }

    const cartAfterOffset = await offsetBatch(cart, invoice.id);
    
    if(!cartAfterOffset || cartAfterOffset.length === 0) return;

    const addMethodAndStatus = {
        ...invoice,
        method: "cash",
        status: "paid",
        data: cartAfterOffset
    };

    if (storeConfig.workMode === "live") {
        await recodeNow(addMethodAndStatus, "invoices");
    }
    
    const current = CurrentTime();

    const page = InvoiceOrder(
        current,
        currencyData.symbol,
        storeSociety.hotline,
        discount2,
        total,
        client,
        invoiceNum,
        empInfo,
        infoSystem,
        storeInvoice,
        isDesktop,
        cart
    );
    const printedRef = { current: false };

    if (page) {
        const afterPrintHandler = () => {
            // prevent dublicate of print order
            if (printedRef.current) return;
            printedRef.current = true;

            page.close();
            setCart([]);

            if (ActivEmp?.role === "delivery" || client?.mode === "payOnline") {
                setClient(intialClient);
            }

            setLoadingProcess(false);
            setSerial("");
        };

        page.onafterprint = afterPrintHandler;
        setTimeout(afterPrintHandler, fallbackDuartion);
    }
    };
    const addOne = (e) => {
        e.preventDefault();
        setAddOne(true);
        if(!product) return;
        setSerial(ResetSerial);
    }

    const resetItem = () => {
        setMoney(0);
        setCart([]);
    }

    const HandleVisaPay = (cash, total) => {
        setEnablePayOnline((prev) => ({...prev, 
            cash: parseFloat(cash).toFixed(2),
            totalVisa: parseFloat(total).toFixed(2),
            status: true,
        }))
    }

    // if getAccess the product returned (soon اان شاء الله)
    const returned = async () => {
        if(!enableReturns.order) {
            return toast.error(t("error:return.serverProblem"));
        }
        enableReturns.order.returned = true;
        const asyncDesicion = MakeAsync(enableReturns.order, "update");
        await update("invoices", asyncDesicion);
        toast.success(t("common:returnSuccess"));
        setEnableReturns(initialReturn);
        setCart([]);
    }
    // control on focus of serial
    useEffect(() => {
        SerialInput.current?.focus();
    }, [cart]);

    return (
        <div className="order-bar">
            <div className='options flex flex-space-bet right'>
                    {enableReturns.session ? 
                    <Returns />
                    :
                    <>
                        <div className='btns'>
                                <button onClick={() => resetItem()} title='trash cart'><img src={TrashIcon} alt='trash' /></button>
                                <button 
                                onClick={() => setEnableReturns((prev)=> ({
                                    ...prev,
                                    session: true
                                }))
                                } title='Returned'><img src={BackIcon} alt='back'/></button>
                        </div>
                        <p className='text-weight-bold uppercase'>{t("common:order")} #{invoiceNum}</p>
                    </>
                    }
            </div>
            {hide.serial &&
                <form onSubmit={addOne}>
                    <input className='inp-serial select' 
                    ref={SerialInput}
                    autoFocus
                    disabled={enableReturns.session || loadingProcess}
                    type='text' 
                    value={serial.code || ""} 
                    onChange={(e) => {
                        setSerial((prev) => ({
                            ...prev,
                            prefix: e.target.value.slice(0, storeConfig?.weight?.prefix.length),
                            code: e.target.value,
                        }))
                    }
                    }
                    placeholder={t("placeholder:pos.barcode")} />
                    <input className='display-ptoduct-serial' disabled type='text' value={product?.nameProudct || ""} placeholder={t("placeholder:pos.productName")} />
                    <button hidden></button>
                </form>
            }
            <div className='head flex'>
                <h3>{t("common:details")}</h3>
                {ActivEmp?.role === "delivery" && <button onClick={() => setEnableDelivery(true)}>{t("action:delivery")}</button>}
            </div>
            <div className='body-order'>
                {Array.isArray(cart) && cart.map((e,i)=>
                    <Ticket pointer={pointer} currency={currencyData.code} barcode={e.barcode} discount={e.discount || {}} key={i} id={e.id} bg={e.img} title={e.name} total={+e.amount} pieces={e.quantity} />
                )}
            </div>
            <div className='footer-order'>
                <div className='calc-rem'>
                    <input type='number' placeholder={t("placeholder:pos.amount")} value={money} disabled={!total} onChange={(e) => setMoney(e.target.value === "" ? "" : Number(e.target.value))} />
                </div>
                <div className='flex flex-align-item-center right flex-space-bet'>
                    <p>{t("common:pos.discount")}:</p>
                    <h5>{discount2 > 0 ? <small>{`-${discount2.toFixed(2)}`}</small> : "0.00"} {currencyData.code}</h5>
                </div>
                <div className='flex flex-align-item-center right flex-space-bet'>
                    <p>{t("common:pos.total")}:</p>
                    <h5>{(total).toFixed(2)} {currencyData.code}</h5>
                </div>
                <div className='flex flex-align-item-center right flex-space-bet'>
                <p>{t("common:pos.reminder")}:</p>
                    <h5>{money !== "" ? (total - money).toFixed(2) : "0.00"} {currencyData.code}</h5>
                </div>
                <div className='btns-order'>
                {enableReturns.btn ?
                <button onClick={() => setAccess(true)} className='orderBtn returnBtn'>{t("action:returnOrder")}</button>
                :
                <>
                    {/* disable the cash and visa btn if the cart is empty */}
                    <button 
                        ref={CashingBtn} 
                        disabled={!cart?.length} 
                        onClick={() => NewInvCash()} 
                        className={`orderBtn ${ActivEmp?.role === "delivery" ? "all" : ""}`}
                    >
                    {t("common:cash")} 
                    </button>
                    {ActivEmp?.role !== "delivery" &&
                    <button disabled={!cart?.length} onClick={() => HandleVisaPay(total, visaTotal)}className='orderBtn'>{t("common:onlinePayment")}</button>
                    }
                </>    
                }
                </div>
            </div>
        </div>
    )
}